import { Typography } from '@mui/material';
import { brandTitleByKey } from '@prismamedia/one-brandkey';
import { InfiniteTable, SearchBar } from '@prismamedia/one-components';
import { useCompareNlWithNlf } from 'NLFactory/hooks/useCompareNlWithNlf';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useGlobalBrandKey, useGlobalSearchParams } from 'utils/globalState';
import { GetNewslettersQuery_newsletters_Newsletter } from '../../../__generated__/queries-newsletter';
import { useGetNewsletters } from '../../../apollo/queries/getNewsletters.newsletter.graphql';
import { AutomationIcon } from '../../../components/AutomationIcon';
import { paths, replaceParams } from '../../../routing';
import { ListPage, PageId } from '../../common/ListPage';

export const NewsletterListPage: FC = () => {
  const history = useHistory();
  const [searchParams, setSearchParams] = useGlobalSearchParams();
  const [brandKey] = useGlobalBrandKey();
  const brandQueryParam = brandKey ? `?brand=${brandKey}` : '';

  const { data, loading, error, fetchMore } = useGetNewsletters({
    where: {
      brandKey,
      name_contains: searchParams?.search,
    },
    first: 100,
    skip: 0,
  });
  useCompareNlWithNlf(data?.newsletters, brandKey);

  return (
    <ListPage
      type={PageId.NEWSLETTER}
      searchBar={
        <SearchBar
          placeholder="Rechercher un template"
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      }
    >
      <InfiniteTable
        list={data?.newsletters}
        loading={loading}
        error={error}
        threshold={50}
        fetchMore={({ startIndex }) =>
          fetchMore({
            variables: {
              skip: startIndex,
            },
          })
        }
        columns={[
          {
            label: 'Id',
            key: '_id',
            width: 70,
          },
          {
            label: 'Nom',
            key: 'name',
            width: 200,
            flexGrow: 1,
          },
          {
            label: 'Marque',
            key: 'brandKey',
            cellDataGetter: ({
              rowData,
            }: {
              rowData: GetNewslettersQuery_newsletters_Newsletter;
            }) => brandTitleByKey[rowData.brandKey],
            width: 200,
            flexGrow: 1,
          },
          {
            label: 'NLF',
            key: 'isFromNlf',
            cellDataGetter: ({
              rowData,
            }: {
              rowData: GetNewslettersQuery_newsletters_Newsletter;
            }) =>
              rowData.isFromNlf ? (
                <Typography>Oui</Typography>
              ) : (
                <Typography>Non</Typography>
              ),
            width: 70,
          },
          {
            label: 'Auto',
            key: 'automationTime',

            cellDataGetter: ({
              rowData,
            }: {
              rowData: GetNewslettersQuery_newsletters_Newsletter;
            }) => <AutomationIcon automationTime={rowData.automationTime} />,
            width: 70,
          },
        ]}
        onRowClick={(
          _,
          newsletter: GetNewslettersQuery_newsletters_Newsletter,
        ) => {
          history.push(
            `${replaceParams(paths.NEWSLETTER_EDIT, {
              id: newsletter.id,
            })}/generalities${brandQueryParam}`,
          );
        }}
      />
    </ListPage>
  );
};
